import { Navigate, Outlet } from 'react-router';
import { useArchivePermissions } from './use-archive-permissions';

/**
 * The route half of `ARCHIVE_GATE` for one page: without `permission` the caller goes to the
 * dashboard; while it is being read nothing renders. Convenience only: the API decides.
 */
export function ArchiveGate({ permission }: { readonly permission: string }) {
  const permissions = useArchivePermissions();
  if (permissions.status === 'loading') return null;
  const open = permissions.status === 'ready' && permissions.permissions.includes(permission);
  return open ? <Outlet /> : <Navigate to="/" replace />;
}
